import { render, staticRenderFns } from "./DkNotification.vue?vue&type=template&id=4f8099c3&"
import script from "./DkNotification.vue?vue&type=script&lang=js&"
export * from "./DkNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports